/*
 * TK: most mezi chatovacím widgetem (assets/tk-chat.js, beze změn) a košíkem Horizonu.
 * Widget po „Do košíku" vyšle na document událost tk-chat:cart-added {variant_id, handle, item, cart, sections}.
 * Horizon není Dawn (nemá getSectionsToRender ani #cart-icon-bubble), proto ji tady přeložíme na jeho
 * vlastní CartUpdateEvent (cart:update): cart-icon.js obnoví počet z data.itemCount a cart-items-component
 * si v draweru překreslí sekci sám. CartAddEvent záměrně neposíláme, drawer se tak neotevře.
 */
(function () {
  if (window.__tkChatBridge) return;
  window.__tkChatBridge = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function loadCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function dispatch(cart, detail) {
    var data = {
      source: 'tk-chat',
      itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
      variantId: detail && detail.variant_id != null ? String(detail.variant_id) : undefined
    };
    import('@theme/events')
      .then(function (m) { document.dispatchEvent(new m.CartUpdateEvent(cart || {}, 'tk-chat', data)); })
      .catch(function () {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart || {}, sourceId: 'tk-chat', data: data };
        document.dispatchEvent(ev);
      });
  }

  document.addEventListener('tk-chat:cart-added', function (e) {
    var detail = (e && e.detail) || {};
    if (detail.cart && typeof detail.cart.item_count === 'number') dispatch(detail.cart, detail);
    else loadCart().then(function (cart) { if (cart) dispatch(cart, detail); });
  });
})();

